exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-header[data-v-0c0b90d1] {\n  padding: 0;\n}\n.page-header[data-v-0c0b90d1] .ant-page-header-heading-title {\n  font-size: 14px;\n}\n.page-header .header-title[data-v-0c0b90d1] {\n  color: #297ede;\n}\n", ""]);

// exports
